export class CrvHistory {

  id: number;
  name: string;
  entityReceiver: string;
  userReceiver: string;
  createdAt: Date;
  
  constructor(history) {
    
    this.id = history.id;
    this.name = history.name;
    this.entityReceiver = history.entityReceiver;
    this.userReceiver = history.userReceiver;
    this.createdAt = history.createdAt;

  }

}
